import { useTranslation } from "react-i18next";
import { DeadlineKind } from "../../../autogen/bff-api";

/**
 * Names each deadline kind. The panel resolves the label from API data, and a bare `t(value)` is
 * invisible to i18next-parser — listing them here as literal calls keeps the keys extracted and
 * translatable, the same pattern as useHomeLabel and useNavLabel.
 */
export const useDeadlineLabel = () => {
  const { t } = useTranslation();
  const labels: Record<DeadlineKind, string> = {
    [DeadlineKind.BidSubmission]: t("Bid deadline"),
    [DeadlineKind.RequestToParticipate]: t("Deadline to request participation"),
    [DeadlineKind.NegotiationRound]: t("Negotiation round deadline"),
    [DeadlineKind.StandstillExpiry]: t("Standstill period ends"),
    [DeadlineKind.ContractStart]: t("Contract starts"),
    [DeadlineKind.ContractEnd]: t("Contract expires"),
    [DeadlineKind.ContractRenewal]: t("Renewal date"),
    [DeadlineKind.ContractTermination]: t("Termination date"),
    [DeadlineKind.ContractNoticeDeadline]: t("Last day to give notice"),
    [DeadlineKind.ContractWarrantyExpiration]: t("Warranty expires"),
    [DeadlineKind.ContractOptionDeadline]: t("Option deadline"),
    [DeadlineKind.ContractOptionStart]: t("Option starts"),
  };
  return (kind: DeadlineKind): string => labels[kind] ?? kind;
};
